export default {
  "code": "fr",
  "title": "Français",
  "flag": "🇫🇷",
  "meta": {
    "index": {
      "title": "De meilleurs travaux universitaires.\n10 fois plus rapide avec l'IA.",
      "description": "Sans Hesse : Vous regardez une page vide pendant des heures.\nAvec Hesse : Vous générez d'excellents textes en appuyant sur un bouton."
    },
    "profile": {
      "title": "Paramètres du profil",
      "description": "Contrôle facilement les paramètres de ton profil"
    }
  },
  "templates": {
    "summarize-text": {
      "headline": "",
      "description": ""
    },
    "find-topic": {
      "headline": "Trouver un sujet",
      "description": "Brainstorming pour obtenir plus d'idées pour un sujet de travail universitaire."
    },
    "find-sources": {
      "headline": "Trouver des sources",
      "description": "Recherche de sources académiques qui pourraient être pertinentes pour le sujet."
    },
    "source-qa": {
      "headline": "Chat des sources",
      "description": "Répondre aux questions sur une source. Ajoutez un lien vers un site web, un document en ligne, ou téléchargez un fichier depuis votre ordinateur."
    },
    "write-outline": {
      "headline": "Créer un plan",
      "description": "Créer un plan approximatif pour un sujet de travail universitaire."
    },
    "write-introduction": {
      "headline": "Écrire une introduction",
      "description": "Créer une introduction pour un travail universitaire."
    },
    "write-chapter": {
      "headline": "Écrire un chapitre",
      "description": "Écrire un chapitre pour un travail universitaire."
    },
    "write-essay": {
      "headline": "Écrire un essai",
      "description": "Écrire un travail universitaire complet."
    },
    "proofreading": {
      "headline": "Relecture",
      "description": "Corriger un texte."
    },
    "freestyle": {
      "headline": "Freestyle",
      "description": "Écrire n'importe quel texte."
    },
    "summarize-document": {
      "headline": "",
      "description": ""
    },
    "summarize-article": {
      "headline": "",
      "description": ""
    },
    "summarize-source": {
      "headline": "",
      "description": ""
    }
  },
  "validations": {
    "required": "{_field_} est un champ obligatoire",
    "min": "{_field_} doit contenir au moins {length} caractères",
    "max": "{_field_} ne doit pas dépasser {length} caractères"
  },
  "buttons": {
    "close": "Fermer",
    "upgrade": "mise à niveau",
    "get_more_words": "Obtenir plus de mots maintenant",
    "login": "connexion",
    "logout": "déconnexion",
    "cancel": "Annuler",
    "yes": "Oui",
    "no": "Non",
    "tryout": "essayer",
    "add": "ajouter",
    "report": "signaler",
    "save": "enregistrer",
    "edit": "modifier",
    "copy": "copier",
    "delete": "supprimer",
    "generate": "générer",
    "signup": "s'inscrire",
    "continue": "continuer",
    "submit": "envoyer",
    "add_source": "Ajouter une source",
    "select_source": "Sélectionner une source",
    "new_document": "Nouveau Document",
    "back": "retour",
    "local_document": {
      "title": "Document PDF depuis mon ordinateur",
      "type": "Téléverse un document PDF"
    },
    "web_document": {
      "title": "Lien web, par exemple Wikipédia",
      "type": "Ajoute un lien web"
    },
    "done": "terminé",
    "discard": "supprimer",
    "ask": "Demande",
    "flag": "Signaler"
  },
  "labels": {
    "missing_subscription": "Vous avez besoin d'un abonnement pour utiliser cet outil.",
    "booked": "ton plan actuel",
    "account": "Compte",
    "subscription": "Abonnement",
    "name": "Nom",
    "email": "Adresse e-mail",
    "limit": "Limite",
    "settings": "Paramètres",
    "words": "Mots",
    "usage": "Utilisation",
    "extra_words": "dont {words} mots supplémentaires",
    "show_all_applications": "Afficher toutes les applications",
    "show_all": "Tout afficher",
    "start_page": "Page d'accueil",
    "is_favorite": "Favori",
    "add_favorite": "Ajouter aux favoris",
    "wordlimit_reached": "Limite de mots atteinte",
    "wordlimit_increase": "Augmenter la limite de mots",
    "contact": "Ouvrir le contact",
    "history": "Historique",
    "show_history": "Afficher l'historique",
    "inprint": "Mentions légales",
    "dataregulation": "Protection des données",
    "tos": "CGV",
    "month": "mois",
    "cancel_anytime": "Annulation à tout moment",
    "try_now": "essayer gratuitement",
    "book_again": "Réserver à nouveau",
    "book": "Changer de plan",
    "upgrade_to": "Passer à {product}",
    "copied_link": "Lien copié",
    "subject": "Sujet",
    "generated_by_hesse": "Généré par Hesse en 3 secondes.",
    "use_template": "Utiliser le modèle",
    "show_mode": "Afficher plus",
    "upload": "télécharger",
    "optional": "facultatif",
    "my_documents": "Mes Documents",
    "my_sources": "Mes Sources",
    "add_source": "Ajouter une source",
    "select_source": "Sélectionner une source",
    "page": "Page {page}",
    "pages": "Pages {from} - {to}",
    "unknown_author": "Auteur inconnu",
    "checker_results": "Résultats du détecteur IA",
    "human": "humain",
    "citation_style": "Style de citation",
    "started_at": "commencé le",
    "ends_at": "se termine le",
    "cancel_subscription": "annuler l'abonnement",
    "file_too_large": "Fichier trop volumineux (max. 50 MB), essaie de le couper",
    "relevance": "Pertinence",
    "relevance_help": "La pertinence mesure dans quelle mesure la source correspond au sujet recherché en termes de contenu.",
    "quality": "Qualité",
    "quality_help": "La qualité mesure la qualité de la source tant sur le fond que sur la forme.",
    "trustworthiness": "Fiabilité",
    "trustworthiness_help": "La fiabilité mesure, principalement sur la base des métadonnées de la source, dans quelle mesure celle-ci est fiable.",
    "high": "élevée",
    "normal": "normale",
    "low": "faible",
    "features": "Fonctionnalités",
    "monthly": "Mensuel",
    "year": "année",
    "yearly": "Annuel",
    "save_50": "économise 50%",
    "pay_amount_per_period": "Paie {amount}/{period}.",
    "focus_of_the_chapter": "Focus du chapitre",
    "reason": "Raison",
    "summary": "Résumé",
    "raw_text": "Texte brut",
    "topic": "Thème",
    "essay_banner_part_1": "🚨 <i>Cette fonctionnalité sera bientôt désactivée</i><br/>Pour <strong>de meilleurs résultats de génération</strong> et <strong>un contrôle plus précis</strong>, nous recommandons d'utiliser l'outil",
    "essay_banner_part_2": "et de générer ton essai <strong>chapitre par chapitre</strong>. Essaie-le pour une expérience d'écriture plus fluide et personnalisée! ✨📖",
    "language": "Langue",
    "language_english_hint": "De nombreux articles universitaires sont publiés en anglais. Nous vous recommandons de rechercher également des sources en anglais pour trouver davantage de résultats pertinents.",
    "length": "Longueur",
    "length_options": [
      {
        "text": "court (4 paragraphes)",
        "value": "short"
      },
      {
        "text": "normal (6 paragraphes)",
        "value": "normal"
      },
      {
        "text": "long (8 paragraphes)",
        "value": "long"
      }
    ],
    "source_type_options": [
      {
        "label": "Recherche de sources automatique",
        "value": "quality"
      },
      {
        "label": "Travail avec vos propres sources",
        "value": "quality_with_sources"
      }
    ],
    "sources": "Sources",
    "source": "Source",
    "open_access": "Open Access",
    "show_only_open_access": "Afficher uniquement les sources en libre accès",
    "essay_outline_options": [
      {
        "value": "generate",
        "label": "Génère un plan pour moi"
      },
      {
        "value": "provide",
        "label": "Utiliser mon propre plan"
      }
    ],
    "your_outline": "Ton plan",
    "year_of_publication": "Année de publication",
    "outline": "Plan",
    "summary_type": "Type de résumé",
    "summary_type_options": [
      {
        "label": "Informatif",
        "value": "informative"
      },
      {
        "label": "Descriptif",
        "value": "descriptive"
      },
      {
        "label": "Critique",
        "value": "critical"
      },
      {
        "label": "Abstrait",
        "value": "abstract"
      }
    ],
    "original_text": "Texte original",
    "maintenance": "Nos services sont en maintenance pour un petit moment. Désolé pour le dérangement et merci pour ta compréhension!",
    "something_wrong": "Vérifie toujours les citations. Quelque chose ne va pas?",
    "bad_citation_title": "Signaler une citation",
    "bad_citation_text": "Dis-nous ce qui ne va pas selon toi dans la citation que tu as signalée.",
    "thanks_for_report": "Merci de nous aider à améliorer Hesse AI!",
    "no_sources_found": "Aucune source trouvée. Essayez d'ajuster votre sujet ou vos filtres de recherche.",
    "user_instruction": "Instructions personnalisées",
    "document": "Document",
    "article": "Article",
    "study_program": "Programme d'études",
    "study_subject": "Matière",
    "interests": "Intérêts",
    "used_for_source_search": "Utilisé pour la recherche de sources",
    "not_used_for_source_search": "Non utilisé pour la recherche de sources",
    "headline": "Focus du chapitre",
    "chapter_length": "Longueur",
    "chapter_length_options": [
      {
        "text": "court (4 paragraphes)",
        "value": "short"
      },
      {
        "text": "normal (6 paragraphes)",
        "value": "normal"
      },
      {
        "text": "long (8 paragraphes)",
        "value": "long"
      }
    ],
    "source_chat_placeholder": "Résumez cette source pour moi...",
    "publish_year": "Année de publication",
    "text": "Texte original",
    "prompt": "Instruction"
  },
  "blog": {
    "written_by": "Écrit par",
    "read_article": "Lire l'article"
  },
  "stages": {
    "searching_sources": "Recherche de sources",
    "filtering_sources": "Filtrage des sources",
    "processing_sources": "Traitement des sources",
    "writing_plan": "Création du plan d'écriture",
    "writing_chapter": "Rédaction du chapitre"
  },
  "source": {
    "select": {
      "empty": {
        "headline": "Rien ici pour le moment.",
        "hint": "Vous pouvez marquer des sources dans 'Trouver des sources' et les utiliser dans divers outils."
      }
    },
    "table": {
      "name": "Nom",
      "type": "Type",
      "created_at": "Créé le"
    },
    "type": {
      "document": "Document",
      "website": "Article",
      "paper": "Article"
    },
    "snippet": {
      "hint": "Le texte du document original peut être étrangement formaté. Dans la plupart des cas, ce n'est pas un problème pour l'IA. Mais nous travaillons à améliorer cela."
    },
    "hint": {
      "not_usable": "Les sources qui ne sont pas encore traitées ne sont pas prises en compte lors de l'écriture."
    },
    "processing": "en cours de traitement...",
    "recent": "utilisé récemment",
    "bookmark": "marquer",
    "bookmarked": "marqué",
    "direct_pdf_access": "Accès PDF direct",
    "source_info": "Informations sur la source"
  },
  "placeholders": {
    "url": "https://www.nature.com/articles/s41586-023-06447-0",
    "topic": "Développement urbain durable : Smart Cities entre innovation et justice sociale",
    "focus_of_the_chapter_legacy": "Transformation numérique",
    "focus_of_the_chapter": "Comment titreriez-vous votre chapitre ?",
    "outline": "I. L'évolution des Smart Cities\n   A. De la ville traditionnelle à la ville connectée\n      1. Définition et concepts fondamentaux\n      2. Moteurs technologiques du développement\n   B. La durabilité comme paradigme central\n      1. Surveillance et protection environnementales\n      2. Optimisation des ressources par l'IoT\nII. Dimensions sociales de la numérisation\n   A. Inclusion et accessibilité\n   B. Souveraineté des données des citoyens\n   C. Surmonter la fracture numérique",
    "original_text": "La physique quantique révolutionne notre compréhension de la réalité au niveau le plus fondamental.\nContrairement à la physique classique, où les particules sont soit des particules soit des ondes, la mécanique quantique montre que la matière peut avoir les deux propriétés simultanément.\nLa célèbre expérience de la double fente démontre cette dualité de manière impressionnante : des photons individuels créent un motif d'interférence comme s'ils passaient par les deux fentes en même temps.\nL'intrication quantique, décrite par Einstein comme une 'action fantôme à distance', permet aux particules de rester instantanément connectées sur de grandes distances.\nCes phénomènes forment la base de technologies révolutionnaires telles que les ordinateurs quantiques et la cryptographie quantique...",
    "chat": "Quelles applications pratiques en découlent ?",
    "report_citation": "Cette citation est inexacte car...",
    "user_instruction": "Analysez l'impact de la numérisation sur les métiers artisanaux traditionnels et montrez des approches de solution",
    "topic_placeholder": "Intelligence artificielle dans l'éducation : Opportunités et défis",
    "outline_placeholder": "I. Introduction à l'éducation soutenue par l'IA\n   A. Définition et fondamentaux\n      1. Qu'est-ce que l'IA dans le contexte éducatif ?\n      2. Développements et tendances actuels\n   B. Potentiels pour l'apprentissage personnalisé\n      1. Systèmes d'apprentissage adaptatifs\n      2. Soutien individuel\nII. Défis et considérations éthiques\n   A. Protection des données et vie privée\n   B. Fracture numérique et accessibilité",
    "document_placeholder": "Recherche_IA_Education.pdf",
    "article_placeholder": "https://www.nature.com/articles/s41586-023-06259-2",
    "study_program_placeholder": "Éducation numérique et pédagogie des médias",
    "study_subject_placeholder": "Humanités numériques",
    "interests_placeholder": "Durabilité, Blockchain, Économie créative",
    "headline_placeholder": "Plateformes d'apprentissage soutenues par l'IA",
    "source_chat_placeholder": "Résumez cette source pour moi...",
    "random_text_placeholder": "L'avenir du travail fait face à un changement révolutionnaire à travers l'intégration de l'intelligence artificielle et des technologies d'automatisation.\nAlors que les emplois traditionnels sont remplacés par des robots et des systèmes d'IA, de nouveaux domaines professionnels et opportunités de carrière émergent simultanément.\nLa capacité de formation continue et d'adaptation aux nouvelles technologies devient une compétence clé dans le monde du travail moderne.\nLe travail à distance et les modèles de travail flexibles gagnent en importance et changent fondamentalement la façon dont nous définissons la collaboration et la productivité.\nLes entreprises doivent de plus en plus faire face aux questions d'éthique numérique, de protection des données et d'équilibre entre efficacité et création de valeur humaine..."
  },
  "groups": {
    "research": "Recherche",
    "essay": "Essai",
    "misc_tools": "Autres outils"
  },
  "flows": {
    "summarize": {
      "headline": "Résumer",
      "description": "Que voulez-vous résumer ?"
    },
    "titles": {
      "summarize_document": "Document",
      "summarize_text": "Texte",
      "summarize_article": "Article",
      "summarize_source": "Source"
    },
    "prefill": {
      "summarize_document": "Résumez-moi le contenu de ce document."
    }
  },
  "messages": {
    "get_more_words": "Obtenir plus de mots maintenant",
    "contact_success": "Merci pour votre message !",
    "error": "Quelque chose n'a pas fonctionné. Veuillez réessayer plus tard.",
    "updated": "{field} mis à jour",
    "failed_to_update": "Échec de la mise à jour de \"{field}\", essaie à nouveau",
    "generic_error": "Ta demande a échoué – essaie plus tard ou contacte le support 😔",
    "upload_error_generic": "Nous n'avons pas pu traiter l'une de tes sources – remplace-la ou utilise nos sources automatiques",
    "upload_error_url": "Nous n'avons pas pu traiter l'URL fournie – si c'est un PDF, essaye de l'uploader directement comme fichier",
    "upload_error_high_no_content": "Nous n'avons pas pu extraire assez d'informations pertinentes d'une de tes sources – remplace-la ou utilise nos sources automatiques",
    "no_snippets_found_error": "Pas assez de sources trouvées pour les données fournies – réessaie avec d'autres infos",
    "account_deletion_error": "Tu ne peux pas supprimer ton compte tant que tu as un abonnement actif. Résilie-le d’abord."
  },
  "validation": {
    "required": "{_field_} est un champ obligatoire",
    "min": "{_field_} doit contenir au moins {length} caractères",
    "max": "{_field_} ne doit pas dépasser {length} caractères",
    "maxarray": "{_field_} a trop d'éléments"
  },
  "domains": {
    "cancellation": {
      "headline": "Annuler l'abonnement",
      "description": "Voulez-vous vraiment annuler votre abonnement ? Pour quelle raison voulez-vous annuler ?",
      "options": [
        {
          "text": "Travail terminé",
          "value": "work_completed"
        },
        {
          "text": "Pas satisfait du produit",
          "value": "unsatisfied_with_product"
        },
        {
          "text": "Trop cher",
          "value": "price_performance_issue"
        },
        {
          "text": "Problèmes techniques",
          "value": "technical_issues"
        },
        {
          "text": "Trouvé un autre fournisseur",
          "value": "found_other_provider"
        },
        {
          "text": "Je ne savais pas que c'était un abonnement",
          "value": "unaware_of_subscription"
        },
        {
          "text": "Autre",
          "value": "other"
        }
      ]
    },
    "try": {
      "headline": "Hesse Pro",
      "loading": "Nous activons votre compte de test..."
    },
    "openai": {
      "status": {
        "unreliable": "Nous avons actuellement une charge serveur élevée. Il peut y avoir des pannes. Si quelque chose ne fonctionne pas, veuillez réessayer plus tard.",
        "working_on_fix": "Il peut y avoir des pannes actuellement. Nous travaillons déjà sur une solution. Veuillez réessayer plus tard."
      }
    },
    "ai_checker": {
      "hint": "Les détecteurs d'IA sont des outils qui vérifient les textes pour le contenu IA. Vous pouvez cliquer sur les cartes pour aller à l'outil correspondant."
    },
    "cookie": {
      "headline": "Cookies 🍪",
      "text1": "Lorsque vous cliquez sur \"Accepter tous les cookies\", vous acceptez le stockage de cookies sur votre appareil pour améliorer la navigation du site, analyser l'utilisation du site et aider nos efforts de marketing.",
      "analytics": "Cookies de performance",
      "analytics_text": "Ces cookies nous permettent d'analyser anonymement le comportement des utilisateurs sur Hesse.ai pour optimiser l'expérience utilisateur.",
      "marketing_text": "Ces cookies peuvent être définis par nos partenaires publicitaires via notre site web. Ils peuvent être utilisés par ces entreprises pour créer un profil de vos intérêts et vous montrer des publicités pertinentes sur d'autres sites.",
      "marketing": "Cookies marketing",
      "technical": "Cookies fonctionnels",
      "technical_text": "Ces cookies sont nécessaires pour assurer une utilisation sécurisée et fiable.",
      "consent": "Accepter tous les cookies",
      "save": "Enregistrer les préférences",
      "decline": "Refuser"
    },
    "write": {
      "save_changes": "Enregistrer les modifications",
      "keep_writing": "Continuer à écrire"
    },
    "feedback": {
      "title": "Donnez-nous des commentaires supplémentaires",
      "description": "Nous essayons constamment d'améliorer nos résultats. Veuillez décrire ce que vous aimeriez avoir changé."
    },
    "report": {
      "title": "Signaler cette réponse ?",
      "reason": "Raison du signalement",
      "description": "Signaler des résultats qui contiennent du contenu critique ou illégal.",
      "result_good": "Le résultat est utile",
      "result_bad": "Le résultat n'est pas utile"
    },
    "pricing": {
      "monthly_wordlimit": "{limit} mots par mois",
      "increase_limit": "Augmenter la limite",
      "wordlimit_reached": "Vous avez atteint votre limite de mots",
      "wordlimit_reached_description": "Le quota pour ce mois a été épuisé. Si vous voulez continuer, vous devez augmenter votre limite.",
      "wordlimit_nearly_reached": "Vos mots sont presque épuisés.",
      "get_more_words": "Obtenir plus de mots",
      "get_more_words_description": "Les textes de haute qualité nécessitent beaucoup de puissance de calcul. C'est cher.<br /> Mais nous avons rendu nos forfaits aussi abordables que possible.",
      "error_title": "La réservation n'a malheureusement pas fonctionné.",
      "error_description": "Contactez-nous - Nous aiderons immédiatement.",
      "text1": "Combien font 10 000 mots ?",
      "text2": "C'était 10 000 mots",
      "referral_title": "Vous ne pouvez pas encore décider ?",
      "referral_title2": "Besoin de plus de mots ?",
      "referral_description": "Partagez votre lien avec des amis. Vous recevrez 1 000 mots gratuits pour chaque nouvelle inscription via votre lien."
    },
    "survey": {
      "title": "Comment évaluez-vous Hesse.ai ?",
      "suggestions": "Que changeriez-vous ?",
      "success_title": "Merci pour vos commentaires !",
      "success_text": "Vous nous aidez à améliorer continuellement Hesse.ai",
      "abort": "ne pas évaluer"
    },
    "cards_hint": {
      "title": "Les cartes mémoire sont maintenant disponibles",
      "subtitle": "Créer automatiquement des <strong>cartes mémoire</strong> à partir de votre <strong>cours</strong> ?",
      "cta": "Créer des cartes mémoire maintenant"
    },
    "share_modal": {
      "headline": "Partager Hesse - obtenir des mots gratuits"
    },
    "login_page": {
      "loading": "Connexion en cours...",
      "error": "La connexion n'a pas réussi",
      "delayed": "La connexion prend plus de temps que d'habitude.<br /> Veuillez vérifier votre connexion Internet et réessayer si nécessaire.",
      "try_again": "Se reconnecter"
    },
    "sidebar": {
      "create_own_application": "Créer votre propre application",
      "hesse_cards": "Cartes Hesse 🃏",
      "all_applications": "Toutes les applications",
      "favourites": "Mes favoris"
    },
    "profile": {
      "title": "Paramètres du profil",
      "limit": "Limite",
      "used_tokens": "Jetons utilisés",
      "get_more_words": "Obtenir plus de mots maintenant",
      "no_subscription": "Vous n'avez pas encore d'abonnement.",
      "upgrade_now": "Mettre à niveau maintenant",
      "manage_subscription": "Gérer l'abonnement",
      "delete_account": "Supprimer le compte",
      "deleted": "Votre compte a été supprimé. Si vous vous connectez, un nouveau compte sera créé."
    },
    "contact": {
      "title": "Contact",
      "subtitle": "Contactez-nous"
    },
    "error_page": {
      "title404": "404 - Page non trouvée",
      "title": "Une erreur s'est produite",
      "text": "Aidez-nous à améliorer Hesse.ai.<br /> Décrivez brièvement ce que vous avez fait immédiatement avant que cette page n'apparaisse.",
      "cta": "Aller à la page d'accueil"
    },
    "success_page": {
      "loading": "chargement...",
      "booking_success": "Votre réservation a réussi !",
      "booked_product": "Vous avez réservé {productName}",
      "start_now": "Commencer maintenant"
    }
  },
  "typewriter": {
    "writeEssay": [
      "Génération de textes...",
      "Chiffrement des textes...",
      "Vérification du plagiat...",
      "Exécution des outils de vérification IA...",
      "Textes plus traçables ✔"
    ],
    "writeOutline": [
      "Génération de textes...",
      "Chiffrement des textes...",
      "Vérification du plagiat...",
      "Exécution des outils de vérification IA...",
      "Textes plus traçables ✔"
    ],
    "writeIntroduction": [
      "Génération de textes...",
      "Chiffrement des textes...",
      "Vérification du plagiat...",
      "Exécution des outils de vérification IA...",
      "Textes plus traçables ✔"
    ]
  },
  "loader": [
    "Évaluation de vos entrées",
    "Ajout de sel et poivre",
    "Pedro, Pedro, Pedro",
    "Secouer la baguette magique",
    "Apporter à votre table"
  ],
  "features": {
    "find-sources": {
      "headline": "Trouver des sources",
      "description": "Recherche de sources académiques qui pourraient être pertinentes pour le sujet."
    },
    "write-outline": {
      "headline": "Créer un plan",
      "description": "Créer un plan approximatif pour un sujet de travail universitaire."
    },
    "write-chapter": {
      "headline": "Écrire un chapitre",
      "description": "Écrire un chapitre pour un travail universitaire."
    },
    "write-essay": {
      "headline": "Écrire un essai",
      "description": "Écrire un travail universitaire."
    },
    "source-qa": {
      "headline": "Chat des sources",
      "description": "Répondre aux questions sur une source. Ajoutez un lien vers un site web ou téléchargez un fichier depuis votre ordinateur."
    },
    "proofreading": {
      "headline": "Relecture",
      "description": "Corriger un texte."
    }
  }
}
